import DBEntity from './DBEntity';

export default class DBIndex extends DBEntity {
  #relatedTable;
  #relatedColumn;

  constructor(name, table, column) {
    super(name);
    this.#relatedTable = table;
    this.#relatedColumn = column;
  }

  setRelatedTable(table) {
    this.#relatedTable = table;
  }

  getRelatedTable() {
    return this.#relatedTable;
  }

  setRelatedColumn(column) {
    this.#relatedColumn = column;
  }

  getRelatedColumn() {
    return this.#relatedColumn;
  }

  getCreationString() {
    const str = `CREATE INDEX ${this.getName()} ON ${this.getRelatedTable()} (${this.getRelatedColumn()});`;
    return str;
  }
}
